enum Environment {
    TESTING = 'testing',
    DEVELOPMENT = 'development',
    PRODUCTION = 'production',
}

export default Environment;
